import {useViewjobProctorAllocation} from "../../proctor/__generated__/ViewjobProctorContext";
import {
    RnMosaicProviderJsPremiumApplicantInsightsTog
} from "../../proctor/__generated__/ViewjobProctorSpecifications";

export function useMosaicProviderJsPremiumApplicantInsightsTogActive(): boolean {
    const proctorAllocation = useViewjobProctorAllocation(RnMosaicProviderJsPremiumApplicantInsightsTog);
    return proctorAllocation.value === 1;
}
